// import React, { useEffect, useState } from 'react'
// import ViewOrderDialogcontainer from './container'
// import { useChangeOrderStatusMutation, useGetOrderDetailsQuery } from 'pages/orders/services';
// import { statusConfigs } from 'utils/constant';
// import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
// import { Backdrop, CircularProgress, Dialog, DialogContent } from '@mui/material';
// import OrderItemChefAssign from '../OrderItemChefAssign';

// const ViewOrderDialog = ({ data, open, onClose, setRefetchMain }) => {
//     const [openConfrim, setOpenConfrim] = useState(false);
//     const [pendingAction, setPendingAction] = useState(null);
//     const [pendingRow, setPendingRow] = useState(null);
//     const [loader, setLoader] = useState(false);
//     const [showBackdropLoader, setShowBackdropLoader] = useState(false);

//     const [assignChefOpen, setAssignChefOpen] = useState(false);
//     const [assignChefData, setAssignChefData] = useState(null); // { orderId, items: [] }
//     const [assignChefSelections, setAssignChefSelections] = useState({});
//     const [pendingStatus, setPendingStatus] = useState(null);

//     // 🔄 NEW: local control to reopen view modal after chef assign
//     const [reopenViewAfterAssign, setReopenViewAfterAssign] = useState(false);

//     const { data: orderDetails,  isLoading, isFetching, refetch } = useGetOrderDetailsQuery(data?.id,
//          { skip: !data?.id, refetchOnMountOrArgChange: false });
//     const [changeStatusApi, { isLoading: isUpdating }] = useChangeOrderStatusMutation();

//     // 🔁 refetch every time modal opens
//     useEffect(() => {
//         if (open && data?.id) {
//             setShowBackdropLoader(true);
//             refetch().finally(() => setShowBackdropLoader(false));
//         }
//     }, [open, data?.id]);

//     const handleStatusChange = async (orderData, newStatus) => {
//         const id = orderData?.id;
//         const body = { order_status: newStatus }
//         setLoader(true);
//         try {
//             const response = await changeStatusApi({ id, body });
//             refetch();
//             if (newStatus == "completed") {
//                 if(setRefetchMain){
//                     setRefetchMain(true);
//                 }
//                 onClose();
//             }
//         } catch (error) {
//             console.log("Error in Changestatus API", error)
//         } finally{
//             setLoader(false);
//         }
//     }

//     const handleStatusWithChefCheck = (order, newStatus) => {
//         const itemsWithoutChef = (order?.orderItems || []).filter(
//             item => 
//             item.stationData?.chefs?.length > 1 && 
//             !item.primary_chef_id
//         );
//           console.log("Items needing chef assignment:", itemsWithoutChef);
//         console.log("Checking items for multiple chefs:", itemsWithoutChef, order, newStatus);
//         if (itemsWithoutChef.length > 0) {
//               // 👇 Close the main modal when Assign Chef opens
//             onClose();
//             setReopenViewAfterAssign(true);
//             console.log("Items needing chef selection:", itemsWithoutChef);
//             // open assign chef modal
//             setAssignChefData({
//                 orderId: order.id,
//                 items: itemsWithoutChef
//             });

//             // Default select first chef in dropdown
//             const selections = {};
//                 itemsWithoutChef.forEach(item => {
//                 selections[item.menu_item_id] = item.stationData.chefs[0].id;
//             });

//             setAssignChefSelections(selections);
//             setPendingStatus(newStatus);
//             setAssignChefOpen(true);
//         } else {
//             // no chef selection needed, just update status
//             handleStatusChange(order, newStatus);
//         }
//     };

//     const handleAssignChefChange = (itemId, chefId) => {
//         setAssignChefSelections(prev => ({
//             ...prev,
//             [itemId]: chefId,
//         }));
//     };

//     const handleAssignChefSubmit = async () => {
//         if (!assignChefData) return;

//         const payload = {
//             order_id: assignChefData.orderId,
//             order_status: pendingStatus,
//             chef_assignments: Object.entries(assignChefSelections).map(([order_item_id, chef_id]) => ({
//             order_item_id: Number(order_item_id),
//             chef_id: Number(chef_id),
//             })),
//         };
//         console.log("Payload for assigning chefs:", payload);
//         try {
//             await changeStatusApi({ id: assignChefData.orderId, body: payload });
//             setAssignChefOpen(false);
//             setAssignChefData(null);
//             setAssignChefSelections({});
//             setPendingStatus(null);
//             refetch();
//             // ✅ Reopen the ViewOrderDialog once chef assignment is done
//             if (reopenViewAfterAssign) {
//                 setTimeout(() => {
//                     setReopenViewAfterAssign(false);
//                     // reopen main modal
//                     setTimeout(() => {
//                         // trigger parent to reopen
//                         if (typeof data?.id !== "undefined") {
//                             // simulate reopen by triggering setRefetchMain or parent handler
//                             if (setRefetchMain) setRefetchMain(true);
//                         }
//                     }, 200);
//                 }, 200);
//             }
//         } catch (error) {
//             console.error("Error submitting chef assignments:", error);
//         }
//     };


//     //  const handleStatusChange = async (orderData, newStatus) => {
//     //     const id = orderData?.id;

//     //     // 1️⃣ Find items that need chef selection (multiple chefs & no primary_chef_id)
//     //     const itemsNeedingChef = (orderData?.orderItems || []).filter(
//     //         item => item.stationData?.chefs?.length > 1 && !item.primary_chef_id
//     //     );

//     //     if (newStatus === "preparing" && itemsNeedingChef.length > 0) {
//     //         // Open Assign Chef modal here (or reuse your existing modal)
//     //         setAssignChefData({
//     //             orderId: orderData.id,
//     //             items: itemsNeedingChef
//     //         });

//     //         // Set default selections (first chef by default)
//     //         const selections = {};
//     //         itemsNeedingChef.forEach(item => {
//     //             selections[item.id] = item.stationData.chefs[0].id;
//     //         });
//     //         setAssignChefSelections(selections);
//     //         setPendingStatus(newStatus);
//     //         setAssignChefOpen(true);
//     //         return; // stop here, wait for chef selection
//     //     }
//     //     console.log("NO NEED TO PASS CHEF ID HERE", itemsNeedingChef, orderData, newStatus);
//     //     const body = { order_status: newStatus }
//     //     setLoader(true);

//     //     // Only pass chef_assignments if items were assigned
//     //     if (newStatus === "preparing" && assignChefSelections) {
//     //         const chefAssignments = Object.entries(assignChefSelections)
//     //             .map(([order_item_id, chef_id]) => ({ order_item_id: Number(order_item_id), chef_id }))
//     //             .filter(a => a.chef_id); // only include assigned

//     //         if (chefAssignments.length > 0) {
//     //             body.chef_assignments = chefAssignments;
//     //         }
//     //     } 
//     //     try {
//     //         const response = await changeStatusApi({ id, body });
//     //         refetch();
//     //         if (newStatus == "completed") {
//     //             if(setRefetchMain){
//     //                 setRefetchMain(true);
//     //             }
//     //             onClose();
//     //         }
//     //     } catch (error) {
//     //         console.log("Error in Changestatus API", error)
//     //     } finally{
//     //         setLoader(false);
//     //     }
//     // }

//     const handleOpenDialog = (row, action) => {
//         setPendingRow(row);
//         setPendingAction(action);
//         setOpenConfrim(true);
//     }

//     const handleCloseDialog = () => {
//         setOpenConfrim(false);
//         setPendingRow(null);
//         setPendingAction(null);
//     };

//     const handleConfirm = async () => {
//         if (pendingRow && pendingAction) {
//             await handleStatusChange(pendingRow, pendingAction);
//         }
//         if(setRefetchMain){
//             setRefetchMain(true);
//         }
//         handleCloseDialog();
//         onClose();
//     };

//     const handleConfirmAssignChef = async () => {
//         if (!assignChefData || !pendingStatus) return;

//         // Prepare payload for selected chefs
//         const chefAssignments = Object.entries(assignChefSelections)
//             .map(([order_item_id, chef_id]) => ({ order_item_id: Number(order_item_id), chef_id }))
//             .filter(a => a.chef_id);

//         if (chefAssignments.length === 0) return;

//         const body = {
//             order_status: pendingStatus,
//             chef_assignments: chefAssignments
//         };

//         setAssignChefOpen(false);
//         setLoader(true);

//         try {
//             await changeStatusApi({ id: assignChefData.orderId, body });
//             refetch();
//             onClose();
//             if (setRefetchMain) setRefetchMain(true);
//         } catch (err) {
//             console.log("Error assigning chef:", err);
//         } finally {
//             setLoader(false);
//             setAssignChefData(null);
//             setPendingStatus(null);
//             setAssignChefSelections({});
//         }
//     };


//     return (
//         <>
//         {(open && showBackdropLoader) ? (
//          <Backdrop open={open && showBackdropLoader} sx={{ zIndex: 2100,color: '#fff'}}>
//             <CircularProgress />
//         </Backdrop> ) : (
//             <Dialog open={open} onClose={onClose} className='view-order-main-dialog' maxWidth="xs" fullWidth 
//                 disableEnforceFocus
//                 TransitionProps={{ appear: false }}
//                 PaperProps={{ sx: { borderRadius: '20px' } }}
//             >
//                 {orderDetails?.data && (
//                             <ViewOrderDialogcontainer
//                                 key={orderDetails?.data?.id}
//                                 viewOrderData={orderDetails?.data}
//                                 open={open}
//                                 onClose={onClose}
//                                 handleStatusChange={handleStatusChange}
//                                 totalItemCount={data?.total_item_count}
//                                 handleOpenDialog={handleOpenDialog}
//                                 loader={loader}
//                                 handleStatusWithChefCheck={handleStatusWithChefCheck}
//                             />
//                 )}
//             </Dialog> 
//         )}

//             <ConfirmationDialog
//                 open={openConfrim}
//                 handleClose={handleCloseDialog}
//                 handleConfirm={handleConfirm}
//                 btnText={'Confirm'}
//                 infoText={`Are you sure you want to change status to ${statusConfigs[pendingAction]?.label.toLowerCase()}?`}
//                 isLoading={isUpdating}
//                 action={statusConfigs[pendingAction]?.label || ''}
//             />

//             <OrderItemChefAssign
//                open={assignChefOpen}
//                 onClose={() => setAssignChefOpen(false)}
//                 orderItems={assignChefData?.items || []}
//                 selections={assignChefSelections}
//                 onChangeChef={handleAssignChefChange}
//                 onSubmit={handleAssignChefSubmit}
//                 // loading={isUpdating}
//             />
//         </>
//     )
// }

// export default ViewOrderDialog

import React, { useEffect, useState } from 'react'
import ViewOrderDialogcontainer from './container'
import { useChangeOrderStatusMutation, useCollectOrderPaymentMutation, useCompleteOrderPaymentMutation, useGetOrderDetailsQuery } from 'pages/orders/services';
import { statusConfigs } from 'utils/constant';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import { Backdrop, CircularProgress, Dialog } from '@mui/material';
import OrderItemChefAssign from '../OrderItemChefAssign';
import OrderRiderAssign from '../OrderRiderAssign';
import CollectOrderPayment from '../CollectOrderPayment';
import { useNavigate } from 'react-router-dom';
import { useSocket } from 'context/SocketContext';

const ViewOrderDialog = ({ data, open, onClose, setRefetchMain, setOpenModal }) => {
    const navigate = useNavigate();
    const [openConfrim, setOpenConfrim] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const [pendingRow, setPendingRow] = useState(null);
    const [loader, setLoader] = useState(false);
    const [showBackdropLoader, setShowBackdropLoader] = useState(false);

    const [assignChefOpen, setAssignChefOpen] = useState(false);
    const [assignChefData, setAssignChefData] = useState(null);
    const [assignChefSelections, setAssignChefSelections] = useState({});
    const [pendingStatus, setPendingStatus] = useState(null);
    const [reopenViewAfterAssign, setReopenViewAfterAssign] = useState(false);

    const [collectPaymentOpen, setCollectPaymentOpen] = useState(false);
    const [paymentRow, setPaymentRow] = useState(null);
    const [paymentModeOrder, setPaymentModeOrder] = useState("cash");

    const [riderAssignOpen, setRiderAssignOpen] = useState(false);
    const [selectedRider, setSelectedRider] = useState(null);

    const [collectPaymentApi, { isLoading: isCollecting }] = useCollectOrderPaymentMutation();
    const [completeOrderPaymentApi, { isLoading: isCompleting }] = useCompleteOrderPaymentMutation();

    const { data: orderDetails, refetch, isFetching } = useGetOrderDetailsQuery(data?.id, {
        skip: !data?.id,
        refetchOnMountOrArgChange: false
    });

    const [changeStatusApi, { isLoading: isUpdating }] = useChangeOrderStatusMutation();
    const socket = useSocket();

    useEffect(() => {
        if (!socket || !data?.id) return;

        const handleUpdate = (updateData) => {
            if (String(updateData.order_id) === String(data.id)) {
                console.log("Socket order update received in ViewOrderDialog:", updateData);
                refetch();
            }
        };

        socket.on('order_status_update', handleUpdate);
        return () => socket.off('order_status_update', handleUpdate);
    }, [socket, data?.id, refetch]);

    // 🔁 Refetch each time modal opens
    useEffect(() => {
        if (open && data?.id) {
            setShowBackdropLoader(true);
            refetch().finally(() => setShowBackdropLoader(false));
        }
    }, [open, data?.id]);

    /** ------------------- STATUS HANDLERS ------------------- **/

    const handleStatusChange = async (orderData, newStatus, extraBody = {}) => {
        const id = orderData?.id;
        const body = { order_status: newStatus, ...extraBody };

        setLoader(true);
        try {
            await changeStatusApi({ id, body });
            await refetch();

            if (newStatus === "completed") {
                setRefetchMain?.(true);
                onClose();
            }
        } catch (error) {
            console.error("Error in changeStatusApi", error);
        } finally {
            setLoader(false);
        }
    };

    const handleStatusWithChefCheck = (order, newStatus) => {
        const itemsWithoutChef = (order?.orderItems || []).filter(
            item => item.stationData?.chefs?.length > 1 && !item.primary_chef_id
        );

        if (itemsWithoutChef.length > 0 && (newStatus === "preparing" || newStatus === "ready_for_chef")) {
            // 🧭 Close view dialog & open assign modal
            onClose();
            setReopenViewAfterAssign(true);

            setAssignChefData({
                orderId: order.id,
                items: itemsWithoutChef
            });

            // Default first chef selected
            const selections = {};
            itemsWithoutChef.forEach(item => {
                const chefs = item.stationData?.chefs || [];
                if (chefs.length > 0) selections[item.menu_item_id] = chefs[0].id;
            });

            setAssignChefOpen(true);
            setAssignChefSelections(selections);
            setPendingStatus(newStatus);
            onClose();
        } else {
            handleStatusChange(order, newStatus);
        }
    };

    const handleStatusWithRiderCheck = (order, newStatus) => {
        if (newStatus === "pickedup" && (order.order_type === "delivery" || order.order_type === "phone_order")) {
            setPendingRow(order);
            setPendingStatus(newStatus);
            setRiderAssignOpen(true);
            onClose();
        } else {
            handleStatusWithChefCheck(order, newStatus);
        }
    }

    /** ------------------- CHEF ASSIGNMENT HANDLERS ------------------- **/

    const handleAssignChefChange = (itemId, chefId) => {
        setAssignChefSelections(prev => ({
            ...prev,
            [itemId]: chefId,
        }));
    };

    const handleAssignChefSubmit = async () => {
        if (!assignChefData) return;

        const payload = {
            order_id: assignChefData.orderId,
            order_status: pendingStatus,
            chef_assignments: Object.entries(assignChefSelections).map(([order_item_id, chef_id]) => ({
                order_item_id: Number(order_item_id),
                chef_id: Number(chef_id),
            })),
        };

        try {
            setLoader(true);
            await changeStatusApi({ id: assignChefData.orderId, body: payload });

            // cleanup
            setAssignChefOpen(false);
            setAssignChefData(null);
            setAssignChefSelections({});
            setPendingStatus(null);
            await refetch();

            // ✅ Reopen main dialog after assigning
            if (reopenViewAfterAssign) {
                setTimeout(() => {
                    setReopenViewAfterAssign(false);
                    setOpenModal(true);
                    setRefetchMain?.(true); // parent reopens ViewOrderDialog
                }, 300);
            }
        } catch (error) {
            console.error("Error submitting chef assignments:", error);
        } finally {
            setLoader(false);
        }
    };

    /** ------------------- CONFIRMATION HANDLERS ------------------- **/

    const handleOpenDialog = (row, action) => {
        setPendingRow(row);
        setPendingAction(action);
        setOpenConfrim(true);
    };

    const handleCloseDialog = () => {
        setOpenConfrim(false);
        setPendingRow(null);
        setPendingAction(null);
    };

    const handleConfirm = async () => {
        try {
            if (pendingAction === "completed") {
                // ✅ Use completeOrderPayment API instead of changeStatus
                const payload = {
                    id: pendingRow?.id,
                    paid_amount: pendingRow?.total_amount, // full amount (already paid)
                    payment_mode: pendingRow?.payment_mode || "cash", // fallback to cash
                };
                await completeOrderPaymentApi(payload);
            } else if (pendingAction === "pickedup") {
                handleStatusWithRiderCheck(pendingRow, pendingAction);
                return; // handleStatusWithRiderCheck will handle the rest
            } else {
                // Default: normal status update
                await handleStatusWithChefCheck(pendingRow, pendingAction);
            }
        } catch (error) {
            console.log("Error in handleConfirm", error);
        } finally {
            handleCloseDialog();
            onClose();
            setRefetchMain?.(true);
        }
    };

    const handleRiderAssignSubmit = async () => {
        if (!pendingRow || !selectedRider) return;

        try {
            await handleStatusChange(pendingRow, "pickedup", { rider_id: selectedRider });
            setRiderAssignOpen(false);
            setPendingRow(null);
            setPendingStatus(null);
            setSelectedRider(null);
            setOpenModal(true); // reopen main modal
            setRefetchMain?.(true);
        } catch (error) {
            console.error("Error in handleRiderAssignSubmit", error);
        }
    };

    // 🔹 called when status "completed" selected
    const handleCompleteFlow = (row) => {
        const alreadyPaid = row?.paid_amount || 0;
        const totalAmount = row?.total_amount || 0;
        if (row?.payment_status !== "paid" || alreadyPaid < totalAmount) {
            // open payment modal
            setPaymentRow(row);
            setCollectPaymentOpen(true);
        } else {
            // open confirmation dialog directly
            handleOpenDialog(row, "completed");
        }
    };

    const handleCollectPayment = async (paymentMode) => {
        if (!paymentRow) return;
        const alreadyPaid = paymentRow?.paid_amount || 0;
        const totalAmount = paymentRow?.total_amount || 0;
        const remainingAmount = totalAmount - alreadyPaid;

        const payload = {
            id: paymentRow?.id,
            paid_amount: remainingAmount > 0 ? parseFloat(remainingAmount).toFixed(2) : parseFloat(totalAmount).toFixed(2),
            payment_mode: paymentMode
        };

        try {
            const res = await collectPaymentApi(payload);
            if (res?.data?.status == 200) {
                setCollectPaymentOpen(false);
                refetch();
            }
        } catch (error) {
            console.log("Error in Collect Payment", error);
        }
    };

    const handleCollectPaymentAndComplete = async (paymentMode) => {
        if (!paymentRow) return;
        const alreadyPaid = paymentRow?.paid_amount || 0;
        const totalAmount = paymentRow?.total_amount || 0;
        const remainingAmount = totalAmount - alreadyPaid;

        const payload = {
            id: paymentRow?.id,
            paid_amount: remainingAmount > 0 ? parseFloat(remainingAmount).toFixed(2) : parseFloat(totalAmount).toFixed(2),
            payment_mode: paymentMode
        };

        try {
            const res = await completeOrderPaymentApi(payload);
            if (res?.data?.status == 200) {
                setCollectPaymentOpen(false);
                refetch();
                setRefetchMain?.(true);
                onClose();
            }
        } catch (error) {
            console.log("Error in Collect Payment & Complete", error);
        }
    };

    const handleDetails = (data) => {
        setOpenModal(false);
        onClose();
        navigate("/order-details", { state: { orderId: data?.id, } });
    }

    /** ------------------- RENDER ------------------- **/

    return (
        <>
            {open && showBackdropLoader ? (
                <Backdrop open sx={{ zIndex: 2100, color: '#fff' }}>
                    <CircularProgress />
                </Backdrop>
            ) : (
                <Dialog
                    open={open}
                    onClose={onClose}
                    className='view-order-main-dialog'
                    maxWidth="xs"
                    fullWidth
                    disableEnforceFocus
                    TransitionProps={{ appear: false }}
                    PaperProps={{ sx: { borderRadius: '20px' } }}
                >
                    {orderDetails?.data && (
                        <ViewOrderDialogcontainer
                            key={orderDetails.data.id}
                            viewOrderData={orderDetails.data}
                            open={open}
                            onClose={onClose}
                            // handleStatusChange={handleStatusChange}
                            handleStatusChange={handleStatusWithRiderCheck}
                            totalItemCount={data?.total_item_count}
                            handleOpenDialog={handleOpenDialog}
                            loader={loader}
                            handleStatusWithChefCheck={handleStatusWithChefCheck}
                            handleCompleteFlow={handleCompleteFlow}
                            handleDetails={handleDetails}
                            handleStatusWithRiderCheck={handleStatusWithRiderCheck}
                        />
                    )}
                </Dialog>
            )}

            <ConfirmationDialog
                open={openConfrim}
                handleClose={handleCloseDialog}
                handleConfirm={handleConfirm}
                btnText="Confirm"
                infoText={`Are you sure you want to change status to ${pendingAction === 'completed' && pendingRow?.order_type === 'delivery' && (pendingRow?.payment_status === "paid" || (pendingRow?.paid_amount && pendingRow?.total_amount && parseFloat(pendingRow?.paid_amount) >= parseFloat(pendingRow?.total_amount)))
                    ? 'delivered & completed'
                    : statusConfigs[pendingAction]?.label?.toLowerCase()
                    }?`}
                isLoading={isUpdating || isCompleting}
                action={
                    pendingAction === 'completed' && pendingRow?.order_type === 'delivery' && (pendingRow?.payment_status === "paid" || (pendingRow?.paid_amount && pendingRow?.total_amount && parseFloat(pendingRow?.paid_amount) >= parseFloat(pendingRow?.total_amount)))
                        ? 'Delivered & Completed'
                        : statusConfigs[pendingAction]?.label || ''
                }
            />

            {/* ✅ Collect Payment Modal */}
            <CollectOrderPayment
                open={collectPaymentOpen}
                onClose={() => setCollectPaymentOpen(false)}
                orderDetails={paymentRow}
                onCollectPayment={handleCollectPayment}
                onCollectAndComplete={handleCollectPaymentAndComplete}
                isCollecting={isCollecting}
                isCompleting={isCompleting}
            />


            <OrderItemChefAssign
                open={assignChefOpen}
                // onClose={() => setAssignChefOpen(false)}
                onClose={() => {
                    setAssignChefOpen(false);
                    setAssignChefData(null);
                    setAssignChefSelections({});
                    setPendingStatus(null);
                    setOpenModal(true);
                }}
                orderItems={assignChefData?.items || []}
                selections={assignChefSelections}
                onChangeChef={handleAssignChefChange}
                onSubmit={handleAssignChefSubmit}
                loading={loader || isUpdating}
            />

            <OrderRiderAssign
                open={riderAssignOpen}
                onClose={() => {
                    setRiderAssignOpen(false);
                    setPendingRow(null);
                    setPendingStatus(null);
                    setSelectedRider(null);
                    setOpenModal(true);
                }}
                onSubmit={handleRiderAssignSubmit}
                loading={loader || isUpdating}
                selectedRider={selectedRider}
                setSelectedRider={setSelectedRider}
                orderDetails={pendingRow}
            />
        </>
    );
};

export default ViewOrderDialog;
